import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { User } from '../../models/user';

@Injectable({ providedIn: 'root' })
export class UserService {
    constructor(private http: HttpClient) {}

    getUser() {
        return this.http.get<User>(`${environment.apiUrl}/user/`);
    }

    updateUser(params) {
        return this.http.put(`${environment.apiUrl}/user/`, params);
    }

    updateUserBillingAddress(params) {
        return this.http.put(`${environment.apiUrl}/user/billing-address/`, params);
    }

    getUserBillingAddress() {
        return this.http.get<User>(`${environment.apiUrl}/user/billing-address/`);
    }

    getUserWallet() {
        return this.http.get(`${environment.apiUrl}/wallet/`);
    }

    getUserTransactionHistory() {
        return this.http.get(`${environment.apiUrl}/payment/transactions`);
    }
}
